import { Platform } from '@angular/cdk/platform';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FusePlatformService {
  private readonly _platform = inject(Platform);

  osName = 'os-unknown';
  browserName = 'browser-unknown';

  constructor() {
    if (!this._platform.isBrowser) return;

    // OS detection
    if (navigator.userAgent.includes('Win')) this.osName = 'os-windows';
    if (navigator.userAgent.includes('Mac')) this.osName = 'os-mac';
    if (navigator.userAgent.includes('X11')) this.osName = 'os-unix';
    if (navigator.userAgent.includes('Linux')) this.osName = 'os-linux';
    if (this._platform.IOS) this.osName = 'os-ios';
    if (this._platform.ANDROID) this.osName = 'os-android';

    // Browser detection
    if (this._platform.BLINK && navigator.userAgent.includes('Edg/')) {
      this.browserName = 'browser-edge';
    } else if (this._platform.BLINK) {
      this.browserName = 'browser-chrome';
    } else if (this._platform.FIREFOX) {
      this.browserName = 'browser-firefox';
    } else if (this._platform.WEBKIT) {
      this.browserName = 'browser-safari';
    } else if (this._platform.EDGE) {
      this.browserName = 'browser-edge';
    } else if (this._platform.TRIDENT) {
      this.browserName = 'browser-ie';
    }
  }

  get isSafari(): boolean {
    return this.browserName === 'browser-safari';
  }
}
